import { ptBrCommonFieldsTranslations } from "../common";

export const jobApplication = {
  name: "Candidatura |||| Candidaturas",
  statusUpdated: "Status atualizado com sucesso",
  statusUpdateError: "Erro ao atualizar status",
  statusTransitionNotAllowed: "Não é possível transicionar de \"%{currentStatus}\" para \"%{targetStatus}\". Status permitidos: %{allowedStatuses}",
  postHireToPreHireTransition: "Não é possível transicionar de status pós-contratação \"%{currentStatus}\" para status pré-contratação \"%{targetStatus}\". Uma vez que uma candidatura entra em um status pós-contratação, ela não pode retornar ao pipeline.",
  outcomeToPipelineTransition: "Não é possível transicionar de status de resultado final \"%{currentStatus}\" para status de pipeline \"%{targetStatus}\". Uma vez que uma candidatura atinge um resultado final, ela não pode retornar ao pipeline.",
  skipHireStatus: "Não é possível transicionar para status pós-contratação \"%{targetStatus}\" sem primeiro ser contratado. As candidaturas devem passar pelo status \"Contratado\" primeiro.",
  statusTransitionValidationWarning: "Esta transição de status não é recomendada. Por favor, revise a configuração do workflow.",
  fields: {
    jobOpeningId: "Vaga",
    candidateName: "Nome do candidato",
    email: "E-mail",
    phone: "Telefone",
    birthDate: "Data de nascimento",
    city: "Cidade",
    state: "Estado",
    resumeUrl: "Link do currículo",
    status: "Status",
    statusId: "Status",
    interviewDate: "Data da entrevista",
    notes: "Observações",
    observations: "Observações",
    sourceId: "Fonte",
    source: "Fonte",
    behavioralProfile: "Perfil comportamental",
    companyId: "Empresa",
    interviewResponsibleId: "Responsável pela entrevista",
    interviewSchedulingResponsibleId: "Responsável pelo agendamento da entrevista",
    supervisorId: "Supervisor",
    startedAt: "Data de início",
    outcome: "Resultado",
    // Column header on the list ("Encerramento - data - motivo"); `outcome`
    // stays as-is because the edit form reuses it as a field label.
    closureOutcome: "Encerramento",
    outcomeAt: "Data do encerramento",
    closureReasonName: "Motivo do encerramento",
    closureReasonId: "Motivo do encerramento",
    closureReasonCategory: "Tipo",
    outcomeHelperText: "Derivado automaticamente do status. Para contratar ou encerrar, mude o status do candidato (com motivo, quando exigido).",
    outcomeChoices: {
      hired: "Contratado",
      closed: "Encerrado",
      rejected: "Rejeitado",
      withdrawn: "Desistiu",
      no_show: "Não Compareceu",
      offer_declined: "Recusou Oferta",
      terminated: "Desligado",
    },
    contactedAt: "Data do primeiro contato",
    interviewScheduledAt: "Data do agendamento",
    completedOnboardingAt: "Data de conclusão da integração",
    hiredAt: "Data de contratação",
    terminatedAt: "Data de desligamento",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  filters: {
    createdFrom: "Criado a partir de",
    createdTo: "Criado até",
    interviewFrom: "Entrevista a partir de",
    interviewTo: "Entrevista até",
    operators: {
      contains: "Contém",
      equals: "Igual a",
      notEquals: "Diferente de",
      gte: "Maior ou igual a",
      lte: "Menor ou igual a",
      in: "Está em",
      isEmpty: "Não preenchido ou vazio",
      isNotEmpty: "Preenchido",
    },
  },
  actions: {
    dashboard: "Dashboard",
    calendar: "Calendário de Entrevistas",
  },
  behavioralProfile: {
    dominant: "Dominante",
    influential: "Influente",
    steady: "Estável",
    compliant: "Conforme",
  },
  tabs: {
    candidateData: "Dados do Candidato",
    profileAndReferences: "Perfil e Referências",
    processAndObservations: "Processo e Observações",
  },
  views: {
    kanban: "Pipeline (Kanban)",
    list: "Lista",
    archive: "Arquivado",
    pipelineTooltip: "Visualização em colunas (Kanban) mostrando apenas aplicações em pipeline (sem resultado ou com resultado recente). Filtros são aplicados no frontend.",
    listTooltip: "Listagem completa com todos os filtros avançados. Busca e análise de todas as aplicações.",
  },
  kanban: {
    hasMore: "Mostrando %{count} de %{total} aplicações. Use os filtros para refinar a busca ou visualize a lista completa na aba \"Lista\".",
  },
  audit: {
    button: "Auditoria",
    title: "Histórico de Auditoria",
    close: "Fechar",
    details: "Detalhes da Auditoria",
    dateTime: "Data e Hora",
    user: "Usuário",
    action: "Ação",
    changes: "Alterações Realizadas",
    additionalInfo: "Informações Adicionais",
    noChanges: "Nenhuma alteração de campo registrada para esta ação.",
    before: "Antes",
    after: "Depois",
    metadata: {
      ip: "Endereço IP",
      userAgent: "Navegador",
    },
    relatedChanges: {
      label: "Mudança Relacionada",
      resourceLabel: "Recurso Relacionado",
      relatedResource: "Recurso Relacionado",
      statusRenamed: "Status \"%{oldName}\" foi renomeado para \"%{newName}\"",
      sourceRenamed: "Fonte \"%{oldName}\" foi renomeada para \"%{newName}\"",
      companyRenamed: "Empresa \"%{oldName}\" foi renomeada para \"%{newName}\"",
      userRenamed: "Usuário \"%{oldName}\" foi renomeado para \"%{newName}\"",
      generic: "Recurso relacionado foi alterado",
    },
  },
  closeApplication: {
    title: "Encerrar candidatura",
    body: "Selecione o motivo do encerramento",
    reasonLabel: "Motivo",
    notesLabel: "Observações (opcional)",
    cancel: "Cancelar",
    confirm: "Confirmar",
    reasonRequired:
      "Selecione um motivo de encerramento antes de salvar",
  },
  linkCandidateUser: {
    title: "Vincular usuário",
    tabCreate: "Criar novo",
    tabLink: "Vincular existente",
    nameLabel: "Nome",
    emailLabel: "Email",
    passwordLabel: "Senha temporária",
    userLabel: "Usuário",
    rolesLabel: "Perfis",
    buttonOnDetail: "Vincular usuário",
    successCreate: "Usuário criado e vinculado",
    successLink: "Usuário vinculado",
    errorOnlyHired: "Apenas candidaturas contratadas podem ter usuário vinculado",
  },
};

export const jobApplicationSource = {
  name: "Fonte de Candidatura |||| Fontes de Candidatura",
  fields: {
    name: "Nome",
    description: "Descrição",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
};

export const jobApplicationClosureReason = {
  name: "Motivo de Encerramento |||| Motivos de Encerramento",
  fields: {
    name: "Nome",
    category: "Categoria",
    phase: "Fase",
    isActive: "Ativo",
    order: "Ordem",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  categoryChoices: {
    candidate_dropout: "Candidato sumiu",
    candidate_decision: "Decisão do candidato",
    company_decision: "Decisão da empresa",
  },
  phaseChoices: {
    pre_hire: "Antes da contratação",
    post_hire: "Após a contratação",
  },
};

export const jobApplicationStatus = {
  name: "Status de Candidatura |||| Status de Candidatura",
  fields: {
    name: "Nome",
    description: "Descrição",
    order: "Ordem",
    triggersMilestone: "Dispara marco",
    triggersOutcome: "Dispara resultado",
    hidesFromKanban: "Ocultar do Kanban",
    autoHideAfterDays: "Ocultar após (dias)",
    isPostHire: "Pós-contratação",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  milestoneLabels: {
    first_contact: "Primeiro Contato",
    interview_scheduled: "Entrevista Agendada",
    started_work: "Iniciou Trabalho",
    completed_onboarding: "Finalizou Integração",
  },
  outcomeLabels: {
    hired: "Contratado",
    rejected: "Rejeitado",
    withdrawn: "Desistiu",
    no_show: "Não Compareceu",
    offer_declined: "Recusou Oferta",
    terminated: "Desligado",
  },
  filters: {
    operators: {
      contains: "Contém",
      equals: "Igual a",
      notEquals: "Diferente de",
      gte: "Maior ou igual a",
      lte: "Menor ou igual a",
    },
  },
  workflow: {
    title: "Gerenciador de Fluxo de Status",
    subtitle: "Visualize e gerencie transições de status",
    loadingError: "Erro ao carregar workflow",
    deleteSuccess: "Transição deletada com sucesso",
    deleteError: "Erro ao deletar transição",
    createSuccess: "Transição criada com sucesso",
    createError: "Erro ao criar transição",
    selfLoopWarning: "Não é possível criar transição para o mesmo status",
    duplicateTransition: "Esta transição já existe",
    selectedTransition: "Transição selecionada ID: %{id}",
    deleteButton: "Deletar Transição",
    refreshButton: "Atualizar",
    viewColumns: "Visualização em Colunas",
    viewGraph: "Visualização em Grafo",
    confirmDelete: "Tem certeza que deseja deletar esta transição?",
    instructions: "Como usar",
    instructionsText: "Para criar uma transição: arraste do nó de origem (parte inferior) para o nó de destino (parte superior). Para deletar: clique na aresta (linha) e use o botão 'Deletar Transição'.",
    modal: {
      statusInfo: "Informações do Status",
      outgoingTransitions: "Transições de Saída",
      incomingTransitions: "Transições de Entrada",
      noOutgoingTransitions: "Nenhuma transição de saída",
      noIncomingTransitions: "Nenhuma transição de entrada",
      addTransition: "Adicionar Nova Transição",
      selectTargetStatus: "Selecione o status de destino",
      createTransition: "Criar Transição",
      close: "Fechar",
    },
    nodeTypes: {
      pipeline: "Pipeline",
      postHire: "Pós-Contratação",
      outcome: "Resultado",
    },
    legend: {
      title: "Legenda",
      pipeline: "Status do processo de seleção",
      postHire: "Status após contratação",
      outcome: "Status de resultado final",
    },
    enforceValidationLabel: "Validar transições",
    validationDisabledWarning: "A validação de transições está desativada. Qualquer transição de status é permitida no momento.",
    configUpdateSuccess: "Configuração atualizada com sucesso",
    configUpdateError: "Erro ao atualizar configuração",
    nodeLabels: {
      milestone: "Marco: %{milestone}",
      outcome: "Resultado: %{outcome}",
    },
    nodeTypesV2: {
      hire: "Contratação",
      terminal: "Encerramento",
      postHire: "Pós-Contratação",
      pipeline: "Pipeline",
    },
    pipelineHealth: {
      tabBuilder: "Construtor",
      tabHealth: "Saúde do Pipeline",
      title: "Saúde do Pipeline",
      subtitle: "Diagnóstico estrutural do funil de contratação",
      loadingError: "Erro ao carregar saúde do pipeline",
      hireStatus: "Status de contratação",
      terminationStatus: "Status de encerramento",
      notConfigured: "Não configurado",
      warningsTitle: "Avisos",
      noWarnings: "Nenhum problema estrutural detectado.",
      statusesTitle: "Status do pipeline",
      flags: {
        hire: "Contratação",
        terminal: "Terminal",
        requiresClosureReason: "Exige motivo de encerramento",
        postHire: "Pós-contratação",
        hiddenFromKanban: "Oculto do Kanban",
      },
      columns: {
        order: "Ordem",
        name: "Nome",
        flags: "Marcadores",
      },
    },
  },
};

export const jobApplicationCalendar = {
  name: "Calendário de Entrevistas |||| Calendários de Entrevistas",
  title: "Calendário de Entrevistas",
  noInterviews: "Sem entrevistas para este dia",
  noCompany: "Sem empresa",
  today: "Hoje",
  exportPdf: "Exportar PDF (imprimir)",
  totalInterviews: "Total de entrevistas no dia: %{count}",
};

export const jobApplicationDashboard = {
  name: "Candidaturas",
  title: "Dashboard de Candidaturas",
  subtitle: "Visão geral do recrutamento no período selecionado",
  dataSince: "Dados desde %{date}. Registros anteriores não entram nas métricas.",
  filters: {
    startDate: "Data inicial",
    endDate: "Data final",
  },
  stats: {
    total: "Total de Candidaturas",
    inPipeline: "Em Pipeline",
    finalized: "Finalizadas",
    thisMonth: "Este Mês",
    contacted: "Contatados",
    interviews: "Entrevistas Agendadas",
    hired: "Contratados",
    startedWork: "Iniciaram Trabalho",
    completedOnboarding: "Completaram Onboarding",
    interviewRate: "Taxa de Entrevista",
    hireRate: "Taxa de Contratação",
    contactRate: "Taxa de Contato",
    startWorkRate: "Taxa de Início",
    onboardingRate: "Taxa de Onboarding",
  },
  charts: {
    byStatus: "Candidaturas por Status",
    bySource: "Candidaturas por Fonte",
    byCompany: "Candidaturas por Empresa",
    hiredByCompany: "Contratados por loja",
    byCity: "Candidaturas por Cidade",
    timeline: "Evolução das Candidaturas",
    behavioralProfile: "Perfil Comportamental",
    funnel: "Funil de Conversão",
    byOutcome: "Distribuição de Resultados",
    milestones: "Marcos Alcançados",
    statusPipeline: "Status: Pipeline vs Pós-Contratação",
    averageTime: "Tempo Médio até Marcos",
    hiredByCompanyAndSource: "Contratados por Loja e Fonte",
    pipeline: "Pipeline",
    postHire: "Pós-Contratação",
    daily: "Diário",
    cumulative: "Acumulado",
    others: "Outros",
    noSource: "Sem fonte",
    noCompany: "Sem empresa",
    noCity: "Sem cidade",
    moreCities: "outras cidades",
    noData: "Sem dados disponíveis",
    tooltips: {
      timeline: "Mostra a evolução temporal das candidaturas criadas ao longo do tempo. A linha azul representa o número diário de novas candidaturas, enquanto a linha laranja mostra o total acumulado desde o início do período.",
      byStatus: "Distribuição de candidaturas por status atual. Mostra quantas candidaturas estão em cada etapa do processo de recrutamento.",
      bySource: "Origem das candidaturas, mostrando quais canais (sites, indicações, redes sociais, etc.) estão gerando mais candidatos.",
      byCompany: "Distribuição de candidaturas por empresa/loja. Útil para identificar quais unidades estão recebendo mais candidatos.",
      byCity: "Distribuição geográfica das candidaturas por cidade. Ajuda a entender a cobertura geográfica do recrutamento.",
      behavioralProfile: "Distribuição dos perfis comportamentais dos candidatos (Analítico, Condutor, Amigável, Expressivo).",
      hiredByCompany: "Quantidade de candidatos contratados por empresa/loja. Mostra quais unidades estão contratando mais.",
      funnel: "Funil de conversão mostrando quantas candidaturas passam por cada etapa: Total → Contatados → Entrevistados → Contratados → Iniciaram Trabalho → Completaram Onboarding. A taxa de conversão mostra a porcentagem que avançou da etapa anterior.",
      byOutcome: "Distribuição dos resultados finais das candidaturas (Contratado, Rejeitado, Desistiu, Não Compareceu, etc.). Candidaturas ainda em pipeline não têm outcome definido.",
      milestones: "Quantidade de candidaturas que alcançaram cada marco importante: Primeiro Contato, Entrevista Agendada, Iniciaram Trabalho e Completaram Onboarding.",
      statusPipeline: "Comparação entre status de pipeline (processo de seleção) e status pós-contratação (após a contratação). Ajuda a visualizar o fluxo completo do processo.",
      averageTime: "Tempo médio em dias desde a criação da candidatura até alcançar cada marco importante. Útil para identificar gargalos e otimizar o processo de recrutamento. Baseado apenas em candidaturas que realmente alcançaram cada etapa.",
      hiredByCompanyAndSource: "Gráfico de barras agrupadas mostrando quantos candidatos foram contratados por cada loja e de quais fontes vieram. Permite identificar quais lojas estão contratando mais e quais canais de recrutamento são mais eficazes para cada unidade.",
    },
  },
  outcomes: {
    inPipeline: "Em Pipeline",
  },
  dashboards: {
    title: "Dashboards",
    tabSourcing: "Captação",
    tabConversion: "Conversão",
    tabRetention: "Retenção",
    tabOperations: "Operações",
    tabOverview: "Visão geral",
    dateRangeLabel: "Período",
    sourcing: {
      total: "Total de candidaturas",
      contacted: "Contatados",
      contactRate: "Taxa de contato",
      bySource: "Candidaturas por fonte",
      byCity: "Candidaturas por cidade (Top 10)",
      byCompany: "Candidaturas por empresa",
      timeline: "Evolução temporal",
    },
    conversion: {
      funnel: "Funil de conversão",
      closureReasons: "Motivos de encerramento (por categoria)",
      exitedFromStatus: "Saídas por status",
      statusTimings: "Tempos por status",
      timingAvg: "Média (dias)",
      timingMin: "Mín",
      timingMax: "Máx",
      timingTotal: "Total",
      timingCount: "Qtd",
      funnelByStage: "Funil por etapa",
      stageReached: "Chegaram",
      stageExited: "Saíram",
      stageConversionToNext: "Conversão p/ próxima",
      tooltips: {
        funnel:
          "Quantos candidatos passam por cada etapa. A queda entre etapas mostra onde se perde gente.",
        closureReasons:
          "Distribuição dos motivos pelos quais candidaturas foram encerradas no período.",
        exitedFromStatus:
          "De qual status o candidato saiu ao ser encerrado — mostra ONDE no funil a perda acontece.",
        statusTimings:
          "Tempo médio/mínimo/máximo que candidatos ficam em cada status. Identifica gargalos.",
        funnelByStage:
          "Quantos candidatos distintos chegaram a cada etapa do funil (medido pelo histórico de status) e quantos saíram em cada uma. Mostra exatamente ONDE no ladder o gap acontece.",
      },
    },
    retention: {
      activeNow: "Ativos agora",
      turnoverRate: "Turnover",
      avgDaysAsHired: "Tempo médio como contratado (dias)",
      cohort: "Safra (mês de contratação)",
      totalHired: "Contratados",
      checkpoint30: "30 dias",
      checkpoint60: "60 dias",
      checkpoint90: "90 dias",
      checkpoint180: "180 dias",
      postHireReasons: "Motivos de saída pós-contratação",
      turnoverByCategory: "Turnover por tipo",
      turnoverCategoryLabels: {
        candidate_decision: "Voluntário (pediu)",
        company_decision: "Involuntário (desligado)",
        candidate_dropout: "Abandono (sumiu)",
      },
      activeHeadcount: "Funcionários ativos",
      tenureActives: "Tempo de permanência (média/mediana)",
      tenureActivesValue: "%{avg}d / %{median}d",
      onboardingGhost: "Sumiço no onboarding",
      tooltips: {
        turnoverRate:
          "Percentual de contratados que saíram (desligados ou pediram pra sair) no período. Quanto menor, melhor a retenção.",
        turnoverRateNoBase:
          "Ainda não dá pra calcular: não havia nenhum funcionário ativo no início do período, então não existe base de comparação. É o esperado nos primeiros meses depois da data de virada dos indicadores — o percentual aparece assim que houver quadro no início do período.",
        avgDaysAsHired:
          "Tempo médio, em dias, que a pessoa ficou como contratada antes de ser desligada, considerando as saídas do período selecionado. Indica quão cedo as pessoas saem.",
        cohort:
          "Safra = grupo de pessoas contratadas no mesmo mês. Acompanhamos quantas continuam ativas 30/60/90/180 dias depois da contratação.",
        activeNow:
          "Quantas pessoas contratadas continuam ativas hoje (sem desligamento registrado). Não depende do período selecionado.",
        postHireReasons:
          "Por que as pessoas saíram DEPOIS de contratadas, considerando as saídas do período selecionado — ajuda a entender se é o trabalho, comissão ou outro fator.",
        turnoverByCategory:
          "Composição das saídas do período por tipo: quanto é gente que PEDIU pra sair (voluntário), quanto a empresa DESLIGOU (involuntário) e quanto simplesmente ABANDONOU (sumiu).",
        activeHeadcount:
          "Funcionários atuais: pessoas que viraram Ativo (a partir da data de virada) e ainda não foram desligadas. Não depende do período selecionado.",
        tenureActives:
          "Há quanto tempo, em dias, os funcionários ATUAIS estão na casa (agora menos a data de contratação). Mostra média e mediana; mede quem está, não só quem saiu.",
        onboardingGhost:
          "Quantos assinaram (Contratado) e sumiram durante o onboarding — encerrados saindo de Contratado/Documentação/Integração/Onboarding antes de virar Ativo.",
      },
    },
    operations: {
      aging: "Tempo no status",
      staleApplications: "Candidaturas paradas",
      candidateName: "Candidato",
      statusName: "Status",
      daysInStatus: "Dias no status",
      bucket: "Faixa",
      count: "Quantidade",
      avgDaysToFirstContact: "Tempo médio até 1º contato",
      daysValue: "%{days} dias",
      uncontactedQueue: "Fila aguardando 1º contato",
      tooltips: {
        aging:
          "Há quanto tempo cada candidatura está parada no status atual, agrupado em faixas (0-3d, 4-7d, 8-15d, +15d). Faixas vermelhas = atenção.",
        staleApplications:
          "Lista de candidaturas paradas há 7 dias ou mais sem mudança de status — candidatos a cobrança ou encerramento.",
        avgDaysToFirstContact:
          "Média de dias entre a criação da candidatura e o 1º contato, considerando candidatos contactados a partir da data de virada. Responde \"o RH demora para falar com o candidato?\".",
        uncontactedQueue:
          "Candidaturas ainda sem 1º contato (em Extração/aguardando), agrupadas por há quanto tempo foram criadas (0-1d, 2-3d, 4-7d, +7d). Faixas vermelhas = atenção.",
      },
    },
    overview: {
      newInPeriod: "Novos no período",
      hiredInPeriod: "Contratados no período",
      activeNow: "Ativos agora",
      turnoverInPeriod: "Turnover no período",
      stuckOver7Days: "Parados +7d",
      totalInPipeline: "No pipeline",
      tooltips: {
        newInPeriod:
          "Candidaturas criadas dentro do período selecionado.",
        hiredInPeriod:
          "Pessoas contratadas dentro do período (pela data de contratação).",
        activeNow:
          "Contratados que continuam ativos hoje. Estado atual — não muda com o período.",
        turnoverInPeriod:
          "Desligamentos registrados no período. Estado atual de saída de contratados.",
        stuckOver7Days:
          "Candidaturas sem mudança de status há mais de 7 dias. Estado atual, ignora período.",
        totalInPipeline:
          "Total de candidaturas ainda em andamento (sem resultado final). Estado atual.",
      },
    },
  },
};
